import { Link, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Users, KeyRound, BarChart3, Trophy, Eye, LogOut } from 'lucide-react';
import { adminLogout } from '@/lib/api';
import { toast } from 'sonner';

const links = [
  { to: '/admin/dashboard', label: 'Dashboard', icon: LayoutDashboard, key: 'dashboard' },
  { to: '/admin/writers', label: 'Writers', icon: Users, key: 'writers' },
  { to: '/admin/accounts', label: 'Writer Logins', icon: KeyRound, key: 'accounts' },
  { to: '/admin/analytics', label: 'Analytics', icon: BarChart3, key: 'analytics' },
  { to: '/admin/achievements', label: 'Our Story', icon: Trophy, key: 'achievements' },
];

export const AdminSidebar = ({ active }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    adminLogout();
    toast.success('Logged out');
    navigate('/admin');
  };

  return (
    <>
      {/* Mobile top nav */}
      <div className="lg:hidden sticky top-0 z-40 bg-surface border-b border-zinc-800">
        <div className="flex items-center justify-between px-4 py-3">
          <span className="font-heading text-xl font-black text-[#CCFF00] tracking-tighter">BORMULA</span>
          <button onClick={handleLogout} className="text-text-secondary hover:text-red-400" data-testid="mobile-logout-button">
            <LogOut className="w-5 h-5" />
          </button>
        </div>
        <div className="flex gap-1 overflow-x-auto px-2 pb-2" data-testid="mobile-admin-nav">
          {links.map(({ to, label, key }) => (
            <Link
              key={key}
              to={to}
              className={`shrink-0 px-3 py-1.5 text-[11px] font-bold uppercase tracking-wider ${key === active ? 'bg-[#CCFF00]/10 text-[#CCFF00]' : 'text-text-secondary hover:text-white'}`}
              data-testid={`mobile-nav-${key}`}
            >
              {label}
            </Link>
          ))}
        </div>
      </div>

      <aside className="fixed left-0 top-0 h-full w-64 bg-surface border-r border-zinc-800 p-6 hidden lg:block">
      <div className="mb-8">
        <span className="font-heading text-2xl font-black text-[#CCFF00] tracking-tighter">BORMULA</span>
        <p className="font-mono text-xs text-text-secondary uppercase mt-1">Admin Panel</p>
      </div>

      <nav className="space-y-2">
        {links.map(({ to, label, icon: Icon, key }) =>
          key === active ? (
            <div key={key} className="flex items-center gap-3 px-4 py-3 bg-[#CCFF00]/10 text-[#CCFF00] rounded-none">
              <Icon className="w-5 h-5" />
              <span className="font-body font-medium">{label}</span>
            </div>
          ) : (
            <Link key={key} to={to} className="flex items-center gap-3 px-4 py-3 text-text-secondary hover:text-white transition-colors" data-testid={`sidebar-${key}-link`}>
              <Icon className="w-5 h-5" />
              <span className="font-body font-medium">{label}</span>
            </Link>
          )
        )}
      </nav>

      <div className="absolute bottom-6 left-6 right-6 space-y-4">
        <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-3 px-4 py-3 text-text-secondary hover:text-white transition-colors">
          <Eye className="w-5 h-5" />
          <span className="font-body">View Site</span>
        </a>
        <button onClick={handleLogout} className="flex items-center gap-3 px-4 py-3 text-text-secondary hover:text-red-400 transition-colors w-full" data-testid="logout-button">
          <LogOut className="w-5 h-5" />
          <span className="font-body">Logout</span>
        </button>
      </div>
    </aside>
    </>
  );
};
